import React from "react";

import { ReactComponent as RightArrowIcon } from "../../../assets/svg/arrow_right.svg";
import { ReactComponent as PICOSmileFace } from "../../../assets/svg/PICO_smile_face_1.svg";
import Modal from "../../../atoms/Modal";
import { IHintIntroduction } from "../../../state";

import styles from "./NotifyHintModal.module.scss";

type Props = {
  targetLessonTitle: string;
  targetHint: IHintIntroduction | undefined;
  onButtonClick: () => void;
  onClose: () => void;
};

const NotifyHintModal: React.FC<Props> = ({
  targetLessonTitle,
  targetHint,
  onButtonClick,
  onClose,
}) => {
  return (
    <Modal className={styles.customModal} onClose={onClose}>
      <div className={styles.wrapper}>
        <div className={styles.flame}>
          <PICOSmileFace />
          <div className={styles.headerContainer}>
            <div className={styles.headerTitle}>
              授業づくりのアイデアが生成されました！
            </div>
            <div className={styles.headerDetail}>
              <span>
                あなたの入力をもとに、PICOが授業運営のアイデアを考えました！
              </span>
              <span>
                「指導書」のPICOアイコンからアイデアをチェックしてみましょう。
              </span>
            </div>
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.titleContainer}>
              <div className={styles.title}>
                {targetLessonTitle}：生徒の興味・関心を引き出すアイデア
              </div>
            </div>
            <div className={styles.dynamicContainer}>
              <div className={styles.dynamicTheme}>{targetHint?.theme}</div>
              <div className={styles.dynamicContent}>{targetHint?.content}</div>
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <button className={styles.closeButton} onClick={onClose}>
              閉じる
            </button>
            <button
              className={styles.checkAnotherIdeaButton}
              onClick={onButtonClick}
            >
              他のアイデアも見てみる <RightArrowIcon />
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default NotifyHintModal;
